import React from "react"
import { MenuLink } from "@reach/menu-button"
import Card from "@kit/design/card"
import Button from "@kit/design/button"
import calloutMap from "app/navigation/utils/callout-map"
import analytics from "utils/analytics"

export default function UpgradeCallout({ userInfo }) {
  const [showCallout, calloutLink, calloutContent] = calloutMap(userInfo)

  return (
    <React.Fragment>
      {showCallout && (
        <MenuLink
          className="rounded-lg settings-note mb-2 p-0 group"
          style={{ padding: 0 }}
          href={calloutLink}
          onClick={trackClick}
        >
          <Card className="bg-blue-50">
            <h2 className="pb-2 text-sm font-semibold group-hover:text-gray-800">
              {calloutContent["header"]}
            </h2>

            <div className="mb-5 text-gray-800 group-hover:text-gray-800 text-sm whitespace-pre-wrap">
              {calloutContent["text"]}
            </div>

            <Button is="primary">{calloutContent["buttonText"]}</Button>
          </Card>
        </MenuLink>
      )}
    </React.Fragment>
  )
}

const trackClick = () => {
  analytics.track(
    "Element",
    "Clicked",
    {
      name: "profile_dropdown_upgrade_now",
      text: "Upgrade now"
    },
    { transport: "beacon" }
  )
}
